import React from 'react'
import { HiEye, HiTrash, HiPencil } from 'react-icons/hi'

const ImagingCarder = ({ heading, counts, viewFunc, children, editFunc, deleteFunc }) => {
  return (
    <div className="card shadow-sm p-3 mb-4 imaging-theme__card">
      <div className="d-flex align-items-center justify-content-between gap-3">
        <div>
          <span className="d-flex align-items-center justify-content-center gap-2">
            <div className="d-flex align-items-center justify-content-center fw-bold imaging-theme__count">{counts}</div>
            <h6 className="card-title m-0 p-0 fw-bold imaging-theme__card-title">{heading}</h6>
          </span>
        </div>
        <span className="d-flex gap-1 imaging-theme__card-actions">
          {viewFunc && (
            <button type="button" onClick={viewFunc} className="imaging-theme__icon-btn imaging-theme__icon-btn--success">
              <HiEye size={20} />
            </button>
          )}
          {editFunc && (
            <button type="button" onClick={editFunc} className="imaging-theme__icon-btn imaging-theme__icon-btn--warning">
              <HiPencil size={20} />
            </button>
          )}
          {deleteFunc && (
            <button type="button" onClick={deleteFunc} className="imaging-theme__icon-btn imaging-theme__icon-btn--danger">
              <HiTrash size={20} />
            </button>
          )}
        </span>
      </div>
    </div>
  )
}

export default ImagingCarder
